import { jsxs, jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { cn } from "../../../lib/utils.js";
import { formatText } from "../../../utils/quiz-parser.js";
import "../shared/quiz-blank.js";
import { KatexText } from "../shared/katex-text.js";
import "react";
import "../shared/quiz-style-context.js";
import "../../../node_modules/.pnpm/hls.js@1.6.15/node_modules/hls.js/dist/hls.js";
import "../../../context/DevToolsContext.js";
import { getImageUrl, getPrintScale, PrintQuizTitle, PrintQuizImage, getStyles, PRINT_CORRECT_ANSWER_CLASS } from "./print-common.js";
const CIRCLED_NUMBERS = ["①", "②", "③", "④", "⑤", "⑥", "⑦", "⑧", "⑨", "⑩"];
function InlinePrint({ quizId, quiz, number, showCorrectAnswers = false, compact }) {
  const { t } = useTranslation("quiz");
  const s = getStyles(compact);
  const imageUrl = getImageUrl(quiz.image, quiz.imagePrint);
  const printScale = getPrintScale(quiz.image, quiz.imagePrint);
  return /* @__PURE__ */ jsxs("div", { className: cn(s.container, s.quizSection), children: [
    /* @__PURE__ */ jsx(PrintQuizTitle, { number, compact, children: /* @__PURE__ */ jsx(KatexText, { text: quiz.title }) }),
    quiz.problem && /* @__PURE__ */ jsx("div", { className: cn(compact ? "text-[15px]" : "text-[16px]", "leading-[30px] px-[40px] text-black"), children: formatText(quiz.problem, `${quizId}-problem`, quiz.additionalImages ?? void 0) }),
    imageUrl && /* @__PURE__ */ jsx(PrintQuizImage, { src: imageUrl, printScale }),
    /* @__PURE__ */ jsx("div", { className: cn("w-full px-[40px]", compact ? "space-y-[10px]" : "space-y-[14px]"), children: (quiz.children ?? []).map((child, childIdx) => /* @__PURE__ */ jsx(
      InlineChildBlockPrint,
      {
        quizId,
        child,
        childIdx,
        showCorrectAnswers,
        compact,
        t
      },
      child.scriptId || childIdx
    )) })
  ] });
}
function InlineChildBlockPrint({
  quizId,
  child,
  childIdx,
  showCorrectAnswers,
  compact,
  t
}) {
  const choices = child.random && Array.isArray(child.random) && child.random.length > 0 ? child.random.map((i) => child.choices[i]).filter(Boolean) : child.choices;
  const correctKeys = new Set(child.choices.filter((c) => c.correct).map((c) => c.key));
  const imageUrl = getImageUrl(child.image, child.imagePrint);
  const printScale = getPrintScale(child.image, child.imagePrint);
  return /* @__PURE__ */ jsxs("div", { className: "space-y-[6px]", children: [
    /* @__PURE__ */ jsx("div", { className: cn(compact ? "text-[13px]" : "text-[14px]", "font-bold text-black"), children: t("types.inline.childLabel", { n: childIdx + 1 }) }),
    child.problem && /* @__PURE__ */ jsx("div", { className: cn(compact ? "text-[14px]" : "text-[15px]", "leading-[28px] text-black"), children: formatText(child.problem, `${quizId}-child-${childIdx}-problem`, child.additionalImages ?? void 0) }),
    imageUrl && /* @__PURE__ */ jsx(PrintQuizImage, { src: imageUrl, printScale }),
    /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-[12px] pointer-events-none", children: choices.map((choice, i) => {
      const isCorrect = correctKeys.has(choice.key);
      const checked = showCorrectAnswers && isCorrect;
      const choiceImageUrl = getImageUrl(choice.image);
      return /* @__PURE__ */ jsxs(
        "div",
        {
          className: cn(
            "inline-flex items-center gap-[6px] px-[10px] py-[4px] border border-black/40 rounded-md",
            checked && PRINT_CORRECT_ANSWER_CLASS
          ),
          style: checked ? { borderColor: "#e50000" } : void 0,
          children: [
            /* @__PURE__ */ jsx(
              "span",
              {
                className: cn(
                  compact ? "text-[14px]" : "text-[16px]",
                  "font-light",
                  checked ? PRINT_CORRECT_ANSWER_CLASS : "text-black"
                ),
                children: CIRCLED_NUMBERS[i] || `${i + 1}`
              }
            ),
            choiceImageUrl && /* @__PURE__ */ jsx(
              "img",
              {
                src: choiceImageUrl,
                alt: `option-${i + 1}`,
                className: "max-h-[28px] w-auto object-contain shrink-0"
              }
            ),
            choice.answer && /* @__PURE__ */ jsx(
              "span",
              {
                className: cn(
                  compact ? "text-[13px]" : "text-[14px]",
                  "leading-[24px]",
                  checked ? PRINT_CORRECT_ANSWER_CLASS : "text-black"
                ),
                children: /* @__PURE__ */ jsx(KatexText, { text: choice.answer })
              }
            )
          ]
        },
        choice.key
      );
    }) })
  ] });
}
export {
  InlinePrint
};
//# sourceMappingURL=inline-print.js.map
